import * as React from "react";

function SvgBeaker(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.01 23.99"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M22.51 20.7c.48.94.71 1.64.24 2.35a2.33 2.33 0 01-2.13.94H2.37c-1.19 0-1.81-.23-2.14-.94S0 21.64.47 20.7L8.53 8.23V1.88h-.95a.86.86 0 01-.71-.24.84.84 0 01-.24-.7.86.86 0 01.24-.71.89.89 0 01.71-.23h8.06a.89.89 0 01.71.23.86.86 0 01.24.71.84.84 0 01-.24.7.86.86 0 01-.71.24h-1v6.35zM12.78 8.23V1.91h-2.12v6.32L5.92 16H17.3" />
    </svg>
  );
}

const MemoSvgBeaker = React.memo(SvgBeaker);
export default MemoSvgBeaker;
